import { put, takeLatest } from "redux-saga/effects";
import { getFileTimelineCRMApi } from "store/api/signtureApi";
import { GET_FILE_TIMELINE_CRM_ACTION } from "../../actions/SignatureAction/actionTypes";

import * as signatureAction from "../../actions/SignatureAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getFileTimelineCRMAction() {
	yield put(globalAction.openLoadingPage());
	const res = yield getFileTimelineCRMApi();
	try {
		if (res?.code === 0) {
			yield put(signatureAction.setFileTimelineCRM(res?.data?.url));
		} else {
			yield put(signatureAction.setFileTimelineCRM(""));
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getFileTimelineCRMSaga() {
	yield takeLatest(GET_FILE_TIMELINE_CRM_ACTION, getFileTimelineCRMAction);
}

export default getFileTimelineCRMSaga;
